
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"22","height":"20","viewBox":"0 0 5.821 5.292"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 1956","transform":"matrix(.05292 0 0 .05292 -870.426 508.212)"}},[_c('rect',{attrs:{"data-name":"Rectangle 3389","width":"110","height":"86","rx":"20","transform":"translate(16449 -9604)","fill":"#1BB58B"}}),_c('rect',{attrs:{"data-name":"Rectangle 3388","width":"110","height":"86","rx":"20","transform":"translate(16449 -9590)","fill":"#0FA"}}),_c('path',{attrs:{"data-name":"Rectangle 3390","d":"M16530-9568h29v32h-29a12 12 0 01-12-12v-8a12 12 0 0112-12z","fill":"#999"}})])])
          )
        }
      }
    